<section class="auth-card" aria-labelledby="auth-tel-title">
  <form
    *ngIf="subStep() === 'enter'"
    class="auth-form"
    [formGroup]="form"
    (ngSubmit)="submitTel()"
  >
    <div class="auth-card__header">
      <pa-button
        icon="pi pi-arrow-left"
        variant="outlined"
        size="small"
        severity="secondary"
        aria-label="Назад"
        (click)="back()"
      />
      <div class="auth-card__intro">
        <h1 class="auth-card__title auth-card__title--left" id="auth-tel-title">Подтвердите телефон</h1>
        <p class="auth-card__subtitle">
          Номер нужен для защиты аккаунта и восстановления доступа
        </p>
      </div>
    </div>

    <div
      class="auth-email-field"
      [class.auth-email-field--error]="!!authErrorMessage()"
    >
      <pa-input-phone
        formControlName="tel"
        [countries]="['RU', 'BY']"
      />
      <p *ngIf="authErrorMessage() as message" class="auth-error" role="alert">
        {{ message }}
      </p>
    </div>

    <pa-button
      label="Подтвердить"
      [fullWidth]="true"
      styleClass="auth-submit"
      [disabled]="isTelEmpty()"
      (click)="submitTel()"
    />

    <pa-button
      *ngIf="canSkip()"
      label="Пропустить"
      variant="outlined"
      severity="secondary"
      [fullWidth]="true"
      styleClass="auth-submit auth-submit--outlined"
      (click)="skip()"
    />

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </form>

  <div *ngIf="subStep() === 'confirm'" class="auth-form">
    <div class="auth-card__header">
      <pa-button
        icon="pi pi-arrow-left"
        variant="outlined"
        size="small"
        severity="secondary"
        aria-label="Назад"
        (click)="back()"
      />
      <div class="auth-card__intro">
        <h1 class="auth-card__title auth-card__title--left" id="auth-tel-title">Подтвердите телефон</h1>
        <!--<p class="auth-card__subtitle"></p>-->
      </div>
    </div>

    <app-tel-confirmation
      [params]="{ tel: store.account().tel }"
      (telConfirmed)="onTelConfirmed()"
      (failedToLoad)="onWidgetFailed()"
    />
  </div>
</section>
